import { logAndNotifyError } from "../modules/logger";
import Notify from "devextreme/ui/notify";

// @import url("../node_modules/ace-builds/css/ace.css");
// @import url("../node_modules/ace-builds/css/theme/dreamweaver.css");
// @import url("../node_modules/ace-builds/css/theme/ambiance.css");
// @import url("../node_modules/devextreme/dist/css/dx.carmine.css");
import { ChangeEventHandler, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { get, getUserInfo, post } from "../modules/server";
import { Alert, Button, Row } from "react-bootstrap";
import { ValueChangedInfo } from "devextreme/ui/editor/editor";
import { EventInfo } from "devextreme/events";
import { DataGrid, List } from "devextreme-react";
import { OptionChangedEventInfo } from "devextreme/core/dom_component";

import ArrayStore from "devextreme/data/array_store";
import dxDataGrid, { EditingStartEvent, NewRowInfo, RowDblClickEvent } from "devextreme/ui/data_grid";
import { Column, Editing, Form, Popup } from "devextreme-react/data-grid";
import { useForm } from "react-hook-form";
import ValidationSummaryMessages from "../components/Configuration/ValidationSummaryMessages";
import TextEditor from "../components/Global/Editors/TextEditor";
import { useNavigate } from "react-router-dom";

const UserChangePassword = () => {
  const formHook = useForm({ defaultValues: { password: "", confirmPassword: "" } });
  const navigate = useNavigate();
  const password = useRef({});

  const {
    handleSubmit,
    watch,
    formState: { errors },
  } = formHook;

  password.current = watch("password", "");

  const onCancel = async () => {
    navigate(-1);
  };

  const onSubmit = async (data: any) => {
    const response = await post("Profile/ChangePassword", data);
    if (response.success) {
      Notify("Lösenordet har ändrats", "success");
      navigate(-1);
    } else Notify(response.message, "error");
  };

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} className="ModuleConfiguratorForm">
        <div style={{ minHeight: "300px", overflow: "auto", paddingRight: 12, paddingLeft: 4 }}>
          <div className="row ml-0">
            <div className="col-lg-12">
              <TextEditor
                label="Ange nuvarande lösenord"
                fieldName={"currentPassword"}
                formHook={formHook as any}
                options={{
                  required: "Du måste ange ditt nuvarande lösenord",
                }}
                isPassword={true}
              ></TextEditor>
            </div>
          </div>
          <div className="row ml-0">
            <div className="col-lg-12">
              <TextEditor
                label="Nytt lösenord"
                fieldName={"password"}
                formHook={formHook as any}
                options={{
                  required: "Du måste ange ett nytt lösenord",
                  minLength: {
                    value: 8,
                    message: "Lösenordet måste bestå av minst 8 tecken",
                  },
                  validate: {
                    atleastOneNonAlphanumericalCharacter: (value: string) => (value.match("[^a-zA-Z0-9]+") ? undefined : "Måste innehålla minst ett icke alphanumeriskt tecken"),
                    atleastOneCapital: (value) => (value.match("[A-Z]+") ? undefined : "Måste innehålla minst en versal"),
                    atleastOneLowerCase: (value) => (value.match("[a-z]+") ? undefined : "Måste innehålla minst en gemen"),
                  },
                }}
                isPassword={true}
              ></TextEditor>
            </div>
          </div>
          <div className="row ml-0">
            <div className="col-lg-12">
              <TextEditor
                label="Bekräfta lösenord"
                fieldName={"confirmPassword"}
                formHook={formHook as any}
                options={{
                  validate: {
                    identical: (value) => value === password.current || "Lösenorden är inte identiska",
                  },
                }}
                isPassword={true}
              ></TextEditor>
            </div>
          </div>
        </div>
        <div className="d-grid gap-2 d-md-flex justify-content-md-end">
          <div className="flex-grow-1">
            <ValidationSummaryMessages errors={errors} />
          </div>
          <div style={{ paddingRight: 12, paddingLeft: 4 }}>
            <button type="button" className="btn btn-secondary ms-2" onClick={onCancel}>
              Avbryt
            </button>
            <button type="submit" className="btn btn-primary ms-2">
              Spara
            </button>
          </div>
        </div>
      </form>
    </>
  );
};

export default UserChangePassword;
